module.exports = __webpack_public_path__ + "img/壘球.548f3b78.jpg";